import ReactDOM from "react-dom";

const openFileDialog = uploadBtnRef => {
  const fileUploadDom = ReactDOM.findDOMNode(uploadBtnRef);
  fileUploadDom.click();
};

export default openFileDialog;
